import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import {
  type CreatePlacementChatChannelRequest,
  useCreateChatChannel,
} from "@src/appV2/ShiftBlocks/api/useCreateChatChannel";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { getPlacementChatPath } from "../paths";

interface PlacementChatWithWorkplaceProps {
  placementId: string;
  workplaceId: string;
}

export function PlacementChatWithWorkplace(props: PlacementChatWithWorkplaceProps) {
  const { placementId, workplaceId } = props;
  const history = useHistory();
  const worker = useDefinedWorker();
  const { mutateAsync: createChatChannel, isLoading: isCreatingChatChannel } =
    useCreateChatChannel<CreatePlacementChatChannelRequest>();

  return (
    <LoadingButton
      invert
      sx={{ width: "fit-content" }}
      isLoading={isCreatingChatChannel}
      disabled={isCreatingChatChannel}
      variant="contained"
      size="small"
      startIconType="text-bubble"
      onClick={async () => {
        await createChatChannel({
          facilityId: workplaceId,
          placementId,
          agentId: worker.userId,
        });

        history.push(getPlacementChatPath(placementId, workplaceId, "chat-with-workplace"));
        logEvent(APP_V2_USER_EVENTS.CHAT_WITH_WORKPLACE, { source: "workplace-profile" });
      }}
    >
      Chat with workplace
    </LoadingButton>
  );
}
